import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { AgencyBusinessModel } from '__generated__/api';

export const getAgencyBusinessModelFilterInput = (searchCriteria: SearchCriteriaModel): AgencyBusinessModel[] | null => {
  if (searchCriteria.agencyBusinessModel && searchCriteria.agencyBusinessModel.length > 0) {
    return searchCriteria.agencyBusinessModel
      .map(type => {
        const result = AgencyBusinessModel[AgencyBusinessModel[type]];

        return result;
      })
      .filter(type => type !== undefined);
  }

  return null;
};
